import { CacheService } from '../services/cache.service';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService, private cache: CacheService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.auth.getToken();
    if (token && req.url.startsWith('/api')) {
      req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
    }
    // Login installs a new session while its own response is being delivered.
    if (!req.url.startsWith('/api') || /\/api\/auth\/(login|logout)\b/.test(req.url)) {
      return next.handle(req);
    }
    return this.cache.track(() => next.handle(req));
  }
}
